import { ReactElement } from 'react';

import { AppSubscriptionError } from '@/components/app/AppSubscriptionError';

export const SubscriptionError = (): ReactElement => {
  return <AppSubscriptionError />;
};
